<template>
  <v-snackbar
    v-model="isSnackbarShowing"
    :bottom="true">
    {{ snackbarMsg }}
    <v-btn
      color="accent"
      flat
      @click="isSnackbarShowing = false">
      {{ $vuetify.t('$vuetify.Snackbar.close') }}
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  name: 'SnackBar',
  data: function () {
    return {
      isSnackbarShowing: false,
      snackbarMsg: null
    }
  },
  methods: {
    showSnackbar: function (msg) {
      this.snackbarMsg = msg
      this.isSnackbarShowing = true
    }
  }
}
</script>

<style scoped>

</style>
